// extracted by mini-css-extract-plugin
export default {"link":"ywgEw","main":"FvlnP","white":"M1vLh","secondary":"lXZ6C","dangerous":"uLiD7","noUnderline":"jURiT"};